import { render, staticRenderFns } from "./CompletedApplications.vue?vue&type=template&id=1fc0b928"
import script from "./CompletedApplications.vue?vue&type=script&lang=js"
export * from "./CompletedApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports